import { PrinterPosRemoveOutlineIcon } from './PrinterPosRemoveOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 796FA5DE-0B9F-4CC4-9FC9-6361639B8751
 * name printer-pos-remove-outline
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-remove-outline.svg
 * tags
 * - Printer 
 */
export const PrinterPointOfSaleRemoveOutlineIcon = PrinterPosRemoveOutlineIcon;
export default PrinterPointOfSaleRemoveOutlineIcon